import { useTranslation } from 'react-i18next';

import { LegacyFieldReadMode } from '~/legacy-components/LegacyForms';

import { getFormattedEmploymentValue } from '../../data';
import { PendingEmploymentComponent } from '../PendingEmploymentComponent';

type Props = {
  label: string;
  currentValue?: string;
  pendingValue?: string;
  isNewEmp?: boolean;
};

export const EmploymentPersonnelGroup = ({
  label,
  currentValue,
  pendingValue,
  isNewEmp,
}: Props) => {
  const { t } = useTranslation();

  return (
    <LegacyFieldReadMode label={t(label)}>
      {getFormattedEmploymentValue(currentValue, '_', ' ')}
      {pendingValue && (
        <PendingEmploymentComponent
          pendingCondition={isNewEmp || currentValue !== pendingValue}
          pendingValue={getFormattedEmploymentValue(pendingValue, '_', ' ')}
          isColorGreen
        />
      )}
    </LegacyFieldReadMode>
  );
};
